import React from "react";
import PropTypes from "prop-types";
import styles from "components/documents/dropdown.scss";
import { documentPropType } from "custom-prop-types";
import { removeExportErrorText } from "utils/regex";
import { DropdownActionsPanel } from "components/documents/documents-grid/dropdown-actions-panel";
import { paymentTypes } from "utils/payment-types";
import { ReceiptForm, OtherDocumentForm } from "components/documents/documents-grid/dropdown-forms";

export const Dropdown = (props) => {
  if (props.focusedDocument.id === null) {
    return null;
  }
  const newStyle = { top: (props.focusedDocument.style.top) + (props.rowHeight * 2) };
  return (
    <div className={ styles.container } style={ newStyle }>
      <DropdownActionsPanel
        { ...props }
        documents={ props.documents }
        focusedDocument={ props.focusedDocument }
        onFocusDocument={ props.onFocusDocument }
        onShowTrashDocument={ props.onShowTrashDocument }
      />
      { renderForm(props, props.focusedDocument) }
    </div>
  );
};

Dropdown.defaultProps = {
  focusedDocument: null
};

Dropdown.propTypes = {
  documents: PropTypes.arrayOf(documentPropType).isRequired,
  focusedDocument: documentPropType,
  onFocusDocument: PropTypes.func.isRequired,
  onShowTrashDocument: PropTypes.func.isRequired,
  rowHeight: PropTypes.number.isRequired
};

const renderForm = (props, focusedDocument) => {
  if (focusedDocument.type === "other") {
    return <OtherDocumentForm { ...props } />;
  }
  return (
    <ReceiptForm
      { ...props }
      formPaymentType={ cleanPaymentType(focusedDocument.paymentType) }
      notes={ removeExportErrorText(focusedDocument.notes) }
    />
  );
};
const cleanPaymentType = (paymentType) => paymentTypes.find((type) => type.key === paymentType.type);



// WEBPACK FOOTER //
// ./src/js/components/documents/documents-grid/dropdown.jsx